import React, { useContext } from "react";

import {
  StyledPropertyList,
  StyledPropertyCard,
  StyledMainImage,
  StyledTag,
} from "./styles";
import assets from "../../assets/index";
import { FlexDiv } from "../FlexDiv";
import { PropertyListInterface } from "./types";
import { LoaderComponent } from "../LoaderComponent";

import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../../contexts/ThemeContext";

const PropertyList = ({
  properties,
  loading,
  onUnitClick,
}: PropertyListInterface) => {
  const navigate = useNavigate();

  if (loading)
    return (
      <FlexDiv direction="column" alignitems="center">
        <LoaderComponent content="Properties loading..." />
      </FlexDiv>
    );

  if (properties && !properties.length)
    return (
      <FlexDiv direction="column" alignitems="center">
        <img src={assets.DissapointmentVector} alt="" width={300} />
        <h4
          style={{
            fontWeight: 500,
            textAlign: "center",
            marginTop: 0,
          }}
        >
          No properties available for booking.
          <br />
          Please try again later
        </h4>
      </FlexDiv>
    );

  return (
    <StyledPropertyList>
      {properties.map((property) => (
        <div key={property.uid}>
          <StyledPropertyCard
            onClick={
              onUnitClick
                ? () => onUnitClick(property.uid)
                : () => navigate(`/unit/${property.uid}`)
            }
          >
            <PropertyInfo property={property} />
          </StyledPropertyCard>
        </div>
      ))}
    </StyledPropertyList>
  );
};

const PropertyInfo = ({ property }: any) => {
  const themeContext = useContext(ThemeContext);

  if (!themeContext) {
    throw new Error("ThemeContext must be used within a ThemeProvider");
  }

  const { themeMode } = themeContext;

  const placeholderImage =
    themeMode === "dark"
      ? assets.imagePlaceholderDark
      : assets.imagePlaceholderWhite;

  return (
    <>
      <StyledMainImage
        alt=""
        src={
          property.mainImage && property.mainImage.image.urls.big
            ? property.mainImage.image.urls.big
            : placeholderImage
        }
        onError={(e) => {
          // Replace the source with the placeholder image if the image fails to load
          (e.target as HTMLImageElement).src = placeholderImage;
        }}
      />
      <h3>
        {property.name}, {property.inUseCity}
      </h3>
      <FlexDiv gap="10px">
        <StyledTag>
          <img src={assets.GuestIcon} alt="guest icon" />
          {property.inUseFeatures.accommodates &&
            property.inUseFeatures.accommodates}
        </StyledTag>
        <StyledTag>
          <img src={assets.BedIcon} alt="bed icon" />
          {property.inUseFeatures.bedrooms || "None"}
        </StyledTag>
        <StyledTag>
          <img src={assets.BathIcon} alt="bath icon" />
          {property.inUseFeatures.bathrooms || "None"}
        </StyledTag>
      </FlexDiv>
      <p>{property.rating}</p>
    </>
  );
};

export default PropertyList;
